var _style, _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "empty_state_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 38 61",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".empty_state_svg__st4{fill:none;stroke:#979797;stroke-width:2;stroke-linecap:round}")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 59.7,
    rx: 19,
    ry: 1,
    opacity: 0.6,
    fill: "#979797"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "empty_state_svg__a",
    d: "M4 0h23.1L38 10.5V44c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    fill: "#f7f7f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 10.9L26.7 1H4C2.3 1 1 2.3 1 4v40c0 1.7 1.3 3 3 3h30c1.7 0 3-1.3 3-3V10.9z",
    fill: "none",
    stroke: "#979797",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M27 0h.3L38 11.2V11H27z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "empty_state_svg__st4",
    d: "M2.7 10.8c1.7-1 3.4-1.4 4.9-1.4s3.1.5 4.6 1.4M15.6.1c-.8.5-1.6.7-2.3.7-.8 0-1.5-.2-2.2-.7M5 .1c-.8.4-1.6.7-2.4.7S1.2.5.4.1",
    transform: "translate(11 20)"
  })));
}
export default SvgEmptyState;